export const CRAWL_LINK_REQUEST = 'CRAWL_LINK_REQUEST';
export const CRAWL_LINK_SUCCESS = 'CRAWL_LINK_SUCCESS';
export const CRAWL_LINK_FAIL = 'CRAWL_LINK_FAIL';
export const CRAWL_LINK_RESET = 'CRAWL_LINK_RESET';
